import React from 'react';
import { Empty } from 'antd';
import './styles.css';

const PreviewEmpty = () => <Empty description={false} />;

export default PreviewEmpty;
